function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#EFF1F2",
  fillRule: "evenodd"
}, React.createElement("ellipse", {
  cx: 3.735,
  cy: 3.718,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 3.735,
  cy: 211.898,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 3.735,
  cy: 105.949,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 3.735,
  cy: 314.13,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 13.072,
  cy: 20.446,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 13.072,
  cy: 226.768,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 13.072,
  cy: 124.537,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 3.735,
  cy: 39.034,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 3.735,
  cy: 245.356,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 3.735,
  cy: 141.266,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 13.072,
  cy: 55.763,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 13.072,
  cy: 262.085,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 13.072,
  cy: 159.853,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 3.735,
  cy: 74.35,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 3.735,
  cy: 278.814,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 3.735,
  cy: 176.582,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 13.072,
  cy: 91.079,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 13.072,
  cy: 297.401,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 13.072,
  cy: 193.311,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 194.21,
  cy: 3.718,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 194.21,
  cy: 211.898,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 194.21,
  cy: 105.949,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 194.21,
  cy: 314.13,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 203.547,
  cy: 20.446,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 203.547,
  cy: 226.768,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 203.547,
  cy: 124.537,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 194.21,
  cy: 39.034,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 194.21,
  cy: 245.356,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 194.21,
  cy: 141.266,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 203.547,
  cy: 55.763,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 203.547,
  cy: 262.085,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 203.547,
  cy: 159.853,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 194.21,
  cy: 74.35,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 194.21,
  cy: 278.814,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 194.21,
  cy: 176.582,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 203.547,
  cy: 91.079,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 203.547,
  cy: 297.401,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 203.547,
  cy: 193.311,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 72.829,
  cy: 3.718,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 72.829,
  cy: 211.898,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 72.829,
  cy: 105.949,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 72.829,
  cy: 314.13,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 82.166,
  cy: 20.446,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 82.166,
  cy: 226.768,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 82.166,
  cy: 124.537,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 72.829,
  cy: 39.034,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 72.829,
  cy: 245.356,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 72.829,
  cy: 141.266,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 82.166,
  cy: 55.763,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 82.166,
  cy: 262.085,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 82.166,
  cy: 159.853,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 72.829,
  cy: 74.35,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 72.829,
  cy: 278.814,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 72.829,
  cy: 176.582,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 82.166,
  cy: 91.079,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 82.166,
  cy: 297.401,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 82.166,
  cy: 193.311,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 265.171,
  cy: 3.718,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 265.171,
  cy: 211.898,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 265.171,
  cy: 105.949,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 265.171,
  cy: 314.13,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 272.641,
  cy: 20.446,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 272.641,
  cy: 226.768,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 272.641,
  cy: 124.537,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 265.171,
  cy: 39.034,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 265.171,
  cy: 245.356,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 265.171,
  cy: 141.266,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 272.641,
  cy: 55.763,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 272.641,
  cy: 262.085,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 272.641,
  cy: 159.853,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 265.171,
  cy: 74.35,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 265.171,
  cy: 278.814,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 265.171,
  cy: 176.582,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 272.641,
  cy: 91.079,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 272.641,
  cy: 297.401,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 272.641,
  cy: 193.311,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 143.79,
  cy: 3.718,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 143.79,
  cy: 211.898,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 143.79,
  cy: 105.949,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 143.79,
  cy: 314.13,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 151.26,
  cy: 20.446,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 151.26,
  cy: 226.768,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 151.26,
  cy: 124.537,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 143.79,
  cy: 39.034,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 143.79,
  cy: 245.356,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 143.79,
  cy: 141.266,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 151.26,
  cy: 55.763,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 151.26,
  cy: 262.085,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 151.26,
  cy: 159.853,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 143.79,
  cy: 74.35,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 143.79,
  cy: 278.814,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 143.79,
  cy: 176.582,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 151.26,
  cy: 91.079,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 151.26,
  cy: 297.401,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 151.26,
  cy: 193.311,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 332.398,
  cy: 3.718,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 332.398,
  cy: 211.898,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 332.398,
  cy: 105.949,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 332.398,
  cy: 314.13,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 332.398,
  cy: 39.034,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 332.398,
  cy: 245.356,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 332.398,
  cy: 141.266,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 332.398,
  cy: 74.35,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 332.398,
  cy: 278.814,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 332.398,
  cy: 176.582,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 22.409,
  cy: 3.718,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 22.409,
  cy: 211.898,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 22.409,
  cy: 105.949,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 22.409,
  cy: 314.13,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 29.878,
  cy: 20.446,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 29.878,
  cy: 226.768,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 29.878,
  cy: 124.537,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 22.409,
  cy: 39.034,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 22.409,
  cy: 245.356,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 22.409,
  cy: 141.266,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 29.878,
  cy: 55.763,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 29.878,
  cy: 262.085,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 29.878,
  cy: 159.853,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 22.409,
  cy: 74.35,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 22.409,
  cy: 278.814,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 22.409,
  cy: 176.582,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 29.878,
  cy: 91.079,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 29.878,
  cy: 297.401,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 29.878,
  cy: 193.311,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 211.017,
  cy: 3.718,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 211.017,
  cy: 211.898,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 211.017,
  cy: 105.949,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 211.017,
  cy: 314.13,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 222.221,
  cy: 20.446,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 222.221,
  cy: 226.768,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 222.221,
  cy: 124.537,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 211.017,
  cy: 39.034,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 211.017,
  cy: 245.356,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 211.017,
  cy: 141.266,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 222.221,
  cy: 55.763,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 222.221,
  cy: 262.085,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 222.221,
  cy: 159.853,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 211.017,
  cy: 74.35,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 211.017,
  cy: 278.814,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 211.017,
  cy: 176.582,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 222.221,
  cy: 91.079,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 222.221,
  cy: 297.401,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 222.221,
  cy: 193.311,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 89.635,
  cy: 3.718,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 89.635,
  cy: 211.898,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 89.635,
  cy: 105.949,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 89.635,
  cy: 314.13,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 100.84,
  cy: 20.446,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 100.84,
  cy: 226.768,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 100.84,
  cy: 124.537,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 89.635,
  cy: 39.034,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 89.635,
  cy: 245.356,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 89.635,
  cy: 141.266,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 100.84,
  cy: 55.763,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 100.84,
  cy: 262.085,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 100.84,
  cy: 159.853,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 89.635,
  cy: 74.35,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 89.635,
  cy: 278.814,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 89.635,
  cy: 176.582,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 100.84,
  cy: 91.079,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 100.84,
  cy: 297.401,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 100.84,
  cy: 193.311,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 281.978,
  cy: 3.718,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 281.978,
  cy: 211.898,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 281.978,
  cy: 105.949,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 281.978,
  cy: 314.13,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 289.448,
  cy: 20.446,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 289.448,
  cy: 226.768,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 289.448,
  cy: 124.537,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 281.978,
  cy: 39.034,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 281.978,
  cy: 245.356,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 281.978,
  cy: 141.266,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 289.448,
  cy: 55.763,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 289.448,
  cy: 262.085,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 289.448,
  cy: 159.853,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 281.978,
  cy: 74.35,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 281.978,
  cy: 278.814,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 281.978,
  cy: 176.582,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 289.448,
  cy: 91.079,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 289.448,
  cy: 297.401,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 289.448,
  cy: 193.311,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 160.597,
  cy: 3.718,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 160.597,
  cy: 211.898,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 160.597,
  cy: 105.949,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 160.597,
  cy: 314.13,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 168.066,
  cy: 20.446,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 168.066,
  cy: 226.768,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 168.066,
  cy: 124.537,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 160.597,
  cy: 39.034,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 160.597,
  cy: 245.356,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 160.597,
  cy: 141.266,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 168.066,
  cy: 55.763,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 168.066,
  cy: 262.085,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 168.066,
  cy: 159.853,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 160.597,
  cy: 74.35,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 160.597,
  cy: 278.814,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 160.597,
  cy: 176.582,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 168.066,
  cy: 91.079,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 168.066,
  cy: 297.401,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 168.066,
  cy: 193.311,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 37.348,
  cy: 3.718,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 37.348,
  cy: 211.898,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 37.348,
  cy: 105.949,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 37.348,
  cy: 314.13,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 46.685,
  cy: 20.446,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 46.685,
  cy: 226.768,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 46.685,
  cy: 124.537,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 37.348,
  cy: 39.034,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 37.348,
  cy: 245.356,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 37.348,
  cy: 141.266,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 46.685,
  cy: 55.763,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 46.685,
  cy: 262.085,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 46.685,
  cy: 159.853,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 37.348,
  cy: 74.35,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 37.348,
  cy: 278.814,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 37.348,
  cy: 176.582,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 46.685,
  cy: 91.079,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 46.685,
  cy: 297.401,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 46.685,
  cy: 193.311,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 229.691,
  cy: 3.718,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 229.691,
  cy: 211.898,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 229.691,
  cy: 105.949,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 229.691,
  cy: 314.13,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 239.028,
  cy: 20.446,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 239.028,
  cy: 226.768,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 239.028,
  cy: 124.537,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 229.691,
  cy: 39.034,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 229.691,
  cy: 245.356,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 229.691,
  cy: 141.266,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 239.028,
  cy: 55.763,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 239.028,
  cy: 262.085,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 239.028,
  cy: 159.853,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 229.691,
  cy: 74.35,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 229.691,
  cy: 278.814,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 229.691,
  cy: 176.582,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 239.028,
  cy: 91.079,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 239.028,
  cy: 297.401,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 239.028,
  cy: 193.311,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 108.309,
  cy: 3.718,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 108.309,
  cy: 211.898,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 108.309,
  cy: 105.949,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 108.309,
  cy: 314.13,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 115.779,
  cy: 20.446,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 115.779,
  cy: 226.768,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 115.779,
  cy: 124.537,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 108.309,
  cy: 39.034,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 108.309,
  cy: 245.356,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 108.309,
  cy: 141.266,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 115.779,
  cy: 55.763,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 115.779,
  cy: 262.085,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 115.779,
  cy: 159.853,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 108.309,
  cy: 74.35,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 108.309,
  cy: 278.814,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 108.309,
  cy: 176.582,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 115.779,
  cy: 91.079,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 115.779,
  cy: 297.401,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 115.779,
  cy: 193.311,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 300.652,
  cy: 3.718,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 300.652,
  cy: 211.898,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 300.652,
  cy: 105.949,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 300.652,
  cy: 314.13,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 308.122,
  cy: 20.446,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 308.122,
  cy: 226.768,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 308.122,
  cy: 124.537,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 300.652,
  cy: 39.034,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 300.652,
  cy: 245.356,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 300.652,
  cy: 141.266,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 308.122,
  cy: 55.763,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 308.122,
  cy: 262.085,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 308.122,
  cy: 159.853,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 300.652,
  cy: 74.35,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 300.652,
  cy: 278.814,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 300.652,
  cy: 176.582,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 308.122,
  cy: 91.079,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 308.122,
  cy: 297.401,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 308.122,
  cy: 193.311,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 179.271,
  cy: 3.718,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 179.271,
  cy: 211.898,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 179.271,
  cy: 105.949,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 179.271,
  cy: 314.13,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 186.74,
  cy: 20.446,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 186.74,
  cy: 226.768,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 186.74,
  cy: 124.537,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 179.271,
  cy: 39.034,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 179.271,
  cy: 245.356,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 179.271,
  cy: 141.266,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 186.74,
  cy: 55.763,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 186.74,
  cy: 262.085,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 186.74,
  cy: 159.853,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 179.271,
  cy: 74.35,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 179.271,
  cy: 278.814,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 179.271,
  cy: 176.582,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 186.74,
  cy: 91.079,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 186.74,
  cy: 297.401,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 186.74,
  cy: 193.311,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 56.022,
  cy: 3.718,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 56.022,
  cy: 211.898,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 56.022,
  cy: 105.949,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 56.022,
  cy: 314.13,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 65.359,
  cy: 20.446,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 65.359,
  cy: 226.768,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 65.359,
  cy: 124.537,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 56.022,
  cy: 39.034,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 56.022,
  cy: 245.356,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 56.022,
  cy: 141.266,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 65.359,
  cy: 55.763,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 65.359,
  cy: 262.085,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 65.359,
  cy: 159.853,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 56.022,
  cy: 74.35,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 56.022,
  cy: 278.814,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 56.022,
  cy: 176.582,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 65.359,
  cy: 91.079,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 65.359,
  cy: 297.401,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 65.359,
  cy: 193.311,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 246.497,
  cy: 3.718,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 246.497,
  cy: 211.898,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 246.497,
  cy: 105.949,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 246.497,
  cy: 314.13,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 253.967,
  cy: 20.446,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 253.967,
  cy: 226.768,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 253.967,
  cy: 124.537,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 246.497,
  cy: 39.034,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 246.497,
  cy: 245.356,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 246.497,
  cy: 141.266,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 253.967,
  cy: 55.763,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 253.967,
  cy: 262.085,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 253.967,
  cy: 159.853,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 246.497,
  cy: 74.35,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 246.497,
  cy: 278.814,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 246.497,
  cy: 176.582,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 253.967,
  cy: 91.079,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 253.967,
  cy: 297.401,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 253.967,
  cy: 193.311,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 125.116,
  cy: 3.718,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 125.116,
  cy: 211.898,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 125.116,
  cy: 105.949,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 125.116,
  cy: 314.13,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 132.586,
  cy: 20.446,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 132.586,
  cy: 226.768,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 132.586,
  cy: 124.537,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 125.116,
  cy: 39.034,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 125.116,
  cy: 245.356,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 125.116,
  cy: 141.266,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 132.586,
  cy: 55.763,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 132.586,
  cy: 262.085,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 132.586,
  cy: 159.853,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 125.116,
  cy: 74.35,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 125.116,
  cy: 278.814,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 125.116,
  cy: 176.582,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 132.586,
  cy: 91.079,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 132.586,
  cy: 297.401,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 132.586,
  cy: 193.311,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 317.459,
  cy: 3.718,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 317.459,
  cy: 211.898,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 317.459,
  cy: 105.949,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 317.459,
  cy: 314.13,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 324.928,
  cy: 20.446,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 324.928,
  cy: 226.768,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 324.928,
  cy: 124.537,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 317.459,
  cy: 39.034,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 317.459,
  cy: 245.356,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 317.459,
  cy: 141.266,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 324.928,
  cy: 55.763,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 324.928,
  cy: 262.085,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 324.928,
  cy: 159.853,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 317.459,
  cy: 74.35,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 317.459,
  cy: 278.814,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 317.459,
  cy: 176.582,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 324.928,
  cy: 91.079,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 324.928,
  cy: 297.401,
  rx: 3.735,
  ry: 3.718
}), React.createElement("ellipse", {
  cx: 324.928,
  cy: 193.311,
  rx: 3.735,
  ry: 3.718
}));

var SvgDots3 = function SvgDots3(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 337,
    height: 318,
    viewBox: "0 0 337 318",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDots3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dots3.5803c5eb.svg";
export { ForwardRef as ReactComponent };